<mat-form-field
  class="{{ selectClass() }}"
  [ngClass]="value() && value().length ? 'has-selected-value' : ''"
  #wrapper
  appearance="outline"
>
  <mat-select
    (selectionChange)="selectionChange($event)"
    [class]="selectElementClass()"
    [panelClass]="cssPanelClass()"
    [placeholder]="label()"
    [value]="value()"
    #selectRef
    multiple
  >
    <mat-select-trigger class="whitespace-nowrap">
      @if (value() && value().length) {
        @if (showLabelPlaceholder()) {
          <span>{{ label() }}</span>
        }
        @if (showSelectedValues()) {
          {{ labelDetails() }}
        }
      }
    </mat-select-trigger>
    <div class="options-action-wrapper">
      <button
        class="options-action-button test-select-all"
        (click)="selectAll()"
      >
        Select All
      </button>
      <button
        class="options-action-button test-clear-all"
        (click)="clearAll()"
      >
        Clear All
      </button>
    </div>
    @for (option of sortingEnabled() ? (options() | sort : 'asc' : 'title') : options(); track $index) {
      <mat-option
        [attr.data-value]="option.value"
        [value]="option.value"
      >
        {{ option.title }}
      </mat-option>
    }
  </mat-select>
  <mat-icon
    class="arrow-down"
    matSuffix
  >
    keyboard_arrow_down
  </mat-icon>
</mat-form-field>
